import React from 'react';
import style from '../../assets/scss/components/pages/MainPage.module.scss';
import { convertKeysToCamelCase } from '../../helpers/baseHelpers';
import { AccountSettings } from '../settings-page/account/AccountSettings';

export const AccountPage: React.FC = () => {
  const { wrapper, contentWrapper } = convertKeysToCamelCase(style);

  return (
    <div className={wrapper}>
      <div className={contentWrapper}>
        <AccountSettings />
      </div>
    </div>
  );
};
